import React, { useState } from "react";
import { Card, CardHeader, CardContent, IconButton, Typography, Box } from "@mui/material";
import { BookOpen as BookOpenIcon, PlusCircle as PlusCircleIcon } from "lucide-react";
import AddCourseForm from "../components/AddCourseForm";
import CourseItem from "../components/CourseItem";
import EmptyMessage from "../components/EmptyMessage";

const headerGradient = "linear-gradient(90deg, #1976d2 0%, #2196f3 100%)";

const CoursesPanel = ({ courses, onRefresh, onSelectCourse }) => {
  const [showAddCourseForm, setShowAddCourseForm] = useState(false);

  return (
    <Card elevation={3} sx={{ overflow: 'hidden', height: '100%' }}>
      <CardHeader
        title={
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <BookOpenIcon size={20} style={{ marginRight: 8 }} />
            <Typography variant="h6" fontWeight="bold">
              Courses
            </Typography>
          </Box>
        }
        action={
          <IconButton color="primary" onClick={() => setShowAddCourseForm(!showAddCourseForm)}>
            <PlusCircleIcon size={20} />
          </IconButton>
        }
        sx={{ 
          background: headerGradient, 
          color: 'white',
          '& .MuiCardHeader-action': { color: 'white' }
        }}
      />
      <CardContent sx={{ p: 2 }}>
        {showAddCourseForm && (
          <AddCourseForm 
            onClose={() => {
              setShowAddCourseForm(false);
              onRefresh();
            }}
          />
        )}
        {courses && courses.length > 0 ? (
          courses.map(course => (
            <CourseItem key={course._id} course={course} onSelectCourse={onSelectCourse} />
          ))
        ) : (
          <EmptyMessage
            message="No courses available"
            showAddButton
            onAddClick={() => setShowAddCourseForm(true)}
          />
        )}
      </CardContent>
    </Card>
  );
};

export default CoursesPanel;
